import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem } from '@mui/material';
import { Language } from '@mui/icons-material';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 80 }}>
      <Select
        value={i18n.language.startsWith('en') ? 'en' : i18n.language}
        onChange={handleLanguageChange}
        startAdornment={<Language sx={{ mr: 1, fontSize: 18 }} />}
        sx={{ 
          color: 'white',
          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
          '& .MuiSelect-icon': { color: 'white' }
        }}
      >
        <MenuItem value="en">EN</MenuItem>
        <MenuItem value="es">ES</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher;